/**
 * Módulo compartilhado para gerenciamento de notas fiscais
 * Usado em ordens de serviço (create e edit)
 */
import { getMasksValidator } from './masks-validator.js';

class NfManager {
    constructor(config = {}) {
        this.config = {
            routes: {
                // Rotas padrão
                deleteNf: config.routes?.deleteNf || '/OS/delete-nf',
                getNf: config.routes?.getNf || '/OS/get-nf',
                addNf: config.routes?.addNf || '/OS/add-nf',
                // updateNf pode ser função ou string base
                updateNf: config.routes?.updateNf || ((id) => `/OS/nf/${id}`),
                ...config.routes
            },
            csrfToken: config.csrfToken || $('meta[name="csrf-token"]').attr('content'),
            ...config
        };
        this.nfsData = [];
        this.isEditPage = this.detectEditMode();
        this.serviceOrderId = this.getServiceOrderId();
        this.init();
    }

    /**
     * Inicializar gerenciamento de NFs
     */
    init() {
        this.setupEventListeners();
        this.setupMasks();
    }

    /**
     * Configurar event listeners
     */
    setupEventListeners() {
        const self = this;
        
        $(document).ready(function() {
            const formNf = document.getElementById('formNfOs');
            if (!formNf) {
                return;
            }

            // Prevenir submissão do formulário
            formNf.addEventListener('submit', function(e) {
                e.preventDefault();
                e.stopPropagation();
            });

            // Salvar NF
            $('#btnSalvarNf').off('click').on('click', function() {
                self.saveNf(formNf);
            });

            // Excluir NF
            $(document).off('click', '.btn-delete-nf').on('click', '.btn-delete-nf', function(e) {
                e.preventDefault();
                self.deleteNf(e);
            });

            // Editar NF
            $(document).off('click', '.btn-edit-nf').on('click', '.btn-edit-nf', function(e) {
                e.preventDefault();
                self.editNf(e);
            });

            // Remover arquivo atual durante edição
            $(document).off('click', '#btnRemoverArquivoNf').on('click', '#btnRemoverArquivoNf', function(e) {
                e.preventDefault();
                $('#modalNf').data('arquivo-removido', true);
                $('#arquivoAtualNfBox').addClass('d-none');
                $('#arquivoNfWrapper').removeClass('d-none');
                // Não exigir novo arquivo; se não enviar, apenas remove
                $('#arquivoNf').prop('required', false);
            });

            // Limpar flags quando o modal for fechado
            $('#modalNf').on('hidden.bs.modal', function() {
                self.closeNfModal(formNf);
            });
        });
    }

    /**
     * Configurar máscaras
     */
    setupMasks() {
        $(document).ready(function() {
            try {
                const masksValidator = getMasksValidator();
                masksValidator.setupMoneyMasks();
            } catch (err) {
                // Caso o plugin de máscara ainda não esteja disponível, apenas ignore
                if (typeof $.fn === 'undefined' || typeof $.fn.mask === 'undefined') {
                    console.warn('jQuery Mask Plugin não carregado ainda; prosseguindo sem aplicar máscara.');
                } else {
                    try {
                        $('.valorMask').mask('000.000.000.000.000,00', { reverse: true });
                    } catch (e) {
                        // Falha silenciosa para não quebrar fluxo de NF
                    }
                }
            }
        });
    }

    /**
     * Salvar nota fiscal
     * @param {HTMLFormElement} formNf - Formulário da NF
     */
    saveNf(formNf) {
        if (!formNf.checkValidity()) {
            formNf.classList.add('was-validated');
            return;
        }

        const formData = new FormData(formNf);
        const nfData = {
            tipo: formData.get('tipo'),
            numero_nota: formData.get('numero_nota'),
            serie: formData.get('serie'),
            data_emissao: formData.get('data_emissao'),
            valor_total: formData.get('valor_total'),
            observacoes: formData.get('observacoes') || ''
        };

        const arquivo = formData.get('arquivo');
        if (arquivo && arquivo.size > 0) {
            nfData.arquivo = arquivo;
            nfData.tipo_arquivo = arquivo.type === 'application/pdf' ? 'pdf' : 'xml';
        }

        const editingIndex = $('#modalNf').data('editing-index');
        const isEditing = $('#modalNf').data('editing');
        const editingNfId = $('#modalNf').data('editing-nf-id');
        const editingExisting = $('#modalNf').data('editing-existing') === true;

        // Na página de edição de OS, persistir imediatamente via AJAX
        if (this.isEditPage) {
            if (isEditing && editingExisting && editingNfId) {
                this.updateExistingNf(nfData, formNf, editingNfId);
                return;
            }
            this.createNfOnEdit(nfData, formNf);
            return;
        }

        // Fluxo original para criação de OS (armazenar em memória)
        if (isEditing && typeof editingIndex !== 'undefined') {
            this.nfsData[editingIndex] = nfData;
        } else {
            this.nfsData.push(nfData);
        }

        this.renderNfTable();
        this.closeNfModal(formNf);
    }

    /**
     * Excluir nota fiscal
     * @param {Event} e - Evento do clique
     */
    deleteNf(e) {
        const $target = $(e.target);
        const nfId = $target.data('nf-id');
        const nfIndex = $target.data('nf-index');
        const row = $target.closest('tr');

        // Se tem data-nf-id (e não tem data-nf-index), é uma NF existente no banco
        if (typeof nfId !== 'undefined' && typeof nfIndex === 'undefined') {
            if (confirm('Tem certeza que deseja excluir esta nota fiscal?')) {
                $.ajax({
                    url: this.config.routes.deleteNf,
                    type: 'POST',
                    data: {
                        nf_id: nfId,
                        _token: this.config.csrfToken
                    },
                    success: function(response) {
                        if (response.success) {
                            row.remove();
                            if ($('.tbodyNf tr').length === 0) {
                                $('.tbodyNf').append('<tr><td colspan="8" class="text-center">Nenhuma nota fiscal cadastrada.</td></tr>');
                            }
                        } else {
                            alert('Erro ao excluir nota fiscal: ' + response.message);
                        }
                    },
                    error: function() {
                        alert('Erro ao excluir nota fiscal. Tente novamente.');
                    }
                });
            }
        } else {
            // NF nova (ainda não salva no banco)
            if (confirm('Tem certeza que deseja excluir esta nota fiscal?')) {
                this.nfsData.splice(nfIndex, 1);
                this.renderNfTable();
            }
        }
    }

    /**
     * Editar nota fiscal
     * @param {Event} e - Evento do clique
     */
    editNf(e) {
        const $target = $(e.currentTarget);
        const nfId = $target.data('nf-id');
        const nfIndex = $target.data('nf-index');
        const isExisting = typeof nfId !== 'undefined' && typeof nfIndex === 'undefined';

        if (isExisting) {
            const self = this;
            $.ajax({
                url: this.config.routes.getNf,
                type: 'POST',
                data: { nf_id: nfId, _token: this.config.csrfToken },
                success: function(response) {
                    if (response && response.success && (response.nf || response.data)) {
                        const nf = response.nf || response.data;
                        $('#tipoNf').val(nf.tipo);
                        $('#numeroNota').val(nf.numero_nota);
                        $('#serieNota').val(nf.serie || '');
                        $('#dataEmissaoNf').val(nf.data_emissao);
                        $('#valorTotalNf').val(nf.valor_total);
                        $('#observacoesNf').val(nf.observacoes || '');

                        $('#modalNf').data('editing-index', null);
                        $('#modalNf').data('editing', true);
                        $('#modalNf').data('editing-nf-id', nf.id);
                        $('#modalNf').data('editing-existing', true);
                        $('#modalNf').data('tipo-arquivo', nf.tipo_arquivo || null);
                        $('#btnSalvarNf').text('Atualizar Nota Fiscal');

                        // UI do arquivo atual
                        if (nf.arquivo) {
                            const downloadBase = (window.serviceOrderConfig && window.serviceOrderConfig.routes && window.serviceOrderConfig.routes.downloadNfBase)
                                ? window.serviceOrderConfig.routes.downloadNfBase
                                : '/OS/nf';
                            const downloadUrl = `${downloadBase}/${nf.id}/download`;
                            const nomeArquivo = nf.nome_arquivo_original || (nf.tipo_arquivo ? `Arquivo ${nf.tipo_arquivo.toUpperCase()}` : 'Arquivo anexado');
                            $('#arquivoAtualNfNome').text(nomeArquivo);
                            $('#arquivoAtualNfDownload').attr('href', downloadUrl);
                            $('#arquivoAtualNfBox').removeClass('d-none');
                            $('#arquivoNfWrapper').addClass('d-none');
                            $('#arquivoNf').prop('required', false);
                            $('#modalNf').data('arquivo-removido', false);
                        } else {
                            $('#arquivoAtualNfBox').addClass('d-none');
                            $('#arquivoNfWrapper').removeClass('d-none');
                            $('#arquivoNf').prop('required', true);
                            $('#modalNf').data('arquivo-removido', false);
                        }

                        const modal = new bootstrap.Modal(document.getElementById('modalNf'));
                        modal.show();
                    } else {
                        alert('Não foi possível carregar os dados da NF.');
                    }
                },
                error: function() {
                    alert('Erro ao buscar dados da nota fiscal.');
                }
            });
        } else {
            const nfData = this.nfsData[nfIndex];
            if (!nfData) return;
            $('#tipoNf').val(nfData.tipo);
            $('#numeroNota').val(nfData.numero_nota);
            $('#serieNota').val(nfData.serie);
            $('#dataEmissaoNf').val(nfData.data_emissao);
            $('#valorTotalNf').val(nfData.valor_total);
            $('#observacoesNf').val(nfData.observacoes || '');

            $('#modalNf').data('editing-index', nfIndex);
            $('#modalNf').data('editing', true);
            $('#modalNf').data('editing-nf-id', null);
            $('#modalNf').data('editing-existing', false);
            $('#btnSalvarNf').text('Atualizar Nota Fiscal');

            // Para NF local, arquivo continua opcional apenas se já existir
            $('#arquivoNf').prop('required', false);
            $('#arquivoAtualNfBox').addClass('d-none');
            $('#arquivoNfWrapper').removeClass('d-none');
            $('#modalNf').removeData('arquivo-removido');

            const modal = new bootstrap.Modal(document.getElementById('modalNf'));
            modal.show();
        }
    }

    /**
     * Renderizar tabela de NFs
     */
    renderNfTable() {
        const tbody = $('.tbodyNf');
        tbody.empty();

        if (this.nfsData.length === 0) {
            tbody.append('<tr><td colspan="8" class="text-center">Nenhuma nota fiscal cadastrada.</td></tr>');
            return;
        }

        this.nfsData.forEach((nf, index) => {
            tbody.append(this.renderNfRow(nf, index));
        });
    }

    /**
     * Renderizar linha da NF
     * @param {Object} nf - Dados da NF
     * @param {number} index - Índice da NF
     * @returns {string} HTML da linha
     */
    renderNfRow(nf, index) {
        const tipoMap = {
            'servico': 'Serviço',
            'produto': 'Produto'
        };
        
        const tipoDoc = nf.tipo_arquivo === 'pdf' ?
            '<i class="sg sg-file-pdf text-danger"></i> PDF'
            : '<i class="sg sg-file-code text-primary"></i> XML';
            
        const arquivoDisplay = nf.nome_arquivo_original
            ? `<span class="badge bg-primary">${nf.nome_arquivo_original}</span>`
            : (nf.arquivo && nf.arquivo.name
                ? `<span class="badge bg-primary">${nf.arquivo.name}</span>`
                : '-');
                
        const dataFormatada = nf.data_emissao ? 
            new Date(nf.data_emissao + 'T00:00:00').toLocaleDateString('pt-BR') 
            : '-';
            
        const valorFormatado = nf.valor_total ? 
            `R$ ${parseFloat(nf.valor_total.toString().replace(',', '.')).toFixed(2).replace('.', ',')}`
            : 'R$ 0,00';

        return `
            <tr class="nf-js" data-local="true">
                <td>${tipoMap[nf.tipo] || nf.tipo}</td>
                <td>${nf.numero_nota}</td>
                <td>${nf.serie}</td>
                <td>${dataFormatada}</td>
                <td>${valorFormatado}</td>
                <td>${tipoDoc}</td>
                <td>${arquivoDisplay}</td>
                <td class="text-end">
                    <div class="dropdown">
                        <a href="#" class="btn btn-link btn-link--hover" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="sg sg-dots-three-vertical-bold"></i>
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item btn-edit-nf" href="#" data-nf-index="${index}"><i class="sg sg-edit me-2"></i>Editar</a></li>
                            <li><a class="dropdown-item btn-delete-nf text-danger" href="#" data-nf-index="${index}"><i class="sg sg-trash me-2"></i>Excluir</a></li>
                        </ul>
                    </div>
                </td>
            </tr>
        `;
    }

    /**
     * Fechar modal de NF
     * @param {HTMLFormElement} formNf - Formulário da NF
     */
    closeNfModal(formNf) {
        const modalNf = bootstrap.Modal.getInstance(document.getElementById('modalNf'));
        if (modalNf) {
            modalNf.hide();
        }
        
        $('#modalNf').removeData('editing-index');
        $('#modalNf').removeData('editing');
        $('#modalNf').removeData('editing-nf-id');
        $('#modalNf').removeData('editing-existing');
        $('#modalNf').removeData('tipo-arquivo');
        $('#btnSalvarNf').text('Salvar Nota Fiscal');

        // Restaurar requisito do arquivo para criação
        $('#arquivoNf').prop('required', true);
        $('#modalNf').removeData('arquivo-removido');
        $('#arquivoAtualNfBox').addClass('d-none');
        $('#arquivoNfWrapper').removeClass('d-none');

        formNf.reset();
        formNf.classList.remove('was-validated');
    }

    /**
     * Detecta se a página é de edição da OS
     */
    detectEditMode() {
        return !!document.querySelector('form[method="post"] input[name="_method"][value="PUT"]');
    }

    /**
     * Obtém o ID da OS da URL ou de elementos da página
     */
    getServiceOrderId() {
        // Tenta por configuração global
        const confId = (window.serviceOrderConfig && window.serviceOrderConfig.orderId) || this.config.orderId;
        if (confId) return parseInt(confId, 10);
        // Tenta extrair da URL /OS/{id}/edit
        const match = window.location.pathname.match(/\/OS\/(\d+)\/edit/);
        if (match && match[1]) return parseInt(match[1], 10);
        // Tenta algum input oculto conhecido
        const el = document.querySelector('#order-id,[name="id_os"]');
        if (el && el.value) return parseInt(el.value, 10);
        return null;
    }

    /**
     * Converte valor monetário do formato brasileiro para ponto flutuante
     */
    toFloatValue(valorStr) {
        if (!valorStr) return 0;
        const s = valorStr.toString().replace(/\./g, '').replace(',', '.');
        const n = parseFloat(s);
        return isNaN(n) ? 0 : n;
    }

    /**
     * Cria NF imediatamente na página de edição via AJAX
     */
    createNfOnEdit(nfData, formNf) {
        if (!this.serviceOrderId) {
            alert('Não foi possível identificar a Ordem de Serviço para salvar a NF.');
            return;
        }
        if (!nfData.arquivo) {
            alert('Selecione o arquivo da nota fiscal (PDF ou XML).');
            return;
        }

        const fd = new FormData();
        fd.append('_token', this.config.csrfToken);
        fd.append('service_order_id', this.serviceOrderId);
        fd.append('tipo', nfData.tipo);
        fd.append('numero_nota', nfData.numero_nota);
        fd.append('serie', nfData.serie || '');
        fd.append('data_emissao', nfData.data_emissao);
        fd.append('valor_total', this.toFloatValue(nfData.valor_total));
        fd.append('observacoes', nfData.observacoes || '');
        fd.append('tipo_arquivo', nfData.tipo_arquivo);
        fd.append('arquivo', nfData.arquivo);

        const self = this;
        $.ajax({
            url: this.config.routes.addNf,
            type: 'POST',
            data: fd,
            processData: false,
            contentType: false,
            success: function(response) {
                const nf = response?.nf || response?.data;
                if (response.success && nf) {
                    self.appendDbNfRow(nf);
                    self.closeNfModal(formNf);
                } else {
                    alert('Erro ao salvar nota fiscal: ' + (response.message || '')); 
                }
            },
            error: function() {
                alert('Erro ao salvar nota fiscal. Tente novamente.');
            }
        });
    }

    /**
     * Atualiza NF existente via AJAX
     */
    updateExistingNf(nfData, formNf, nfId) {
        const fd = new FormData();
        fd.append('_token', this.config.csrfToken);
        fd.append('_method', 'PUT');
        fd.append('tipo', nfData.tipo);
        fd.append('numero_nota', nfData.numero_nota);
        fd.append('serie', nfData.serie || '');
        fd.append('data_emissao', nfData.data_emissao);
        fd.append('valor_total', this.toFloatValue(nfData.valor_total));
        fd.append('observacoes', nfData.observacoes || '');

        // tipo_arquivo agora é opcional no update; reaproveita existente se não houve novo arquivo
        const tipoArquivoExistente = $('#modalNf').data('tipo-arquivo');
        if (nfData.tipo_arquivo) {
            fd.append('tipo_arquivo', nfData.tipo_arquivo);
        } else if (tipoArquivoExistente && !$('#modalNf').data('arquivo-removido')) {
            fd.append('tipo_arquivo', tipoArquivoExistente);
        }
        if (nfData.arquivo) {
            fd.append('arquivo', nfData.arquivo);
        }

        // Se usuário optou por remover o arquivo e não anexou outro
        if ($('#modalNf').data('arquivo-removido') && !nfData.arquivo) {
            fd.append('remover_arquivo', '1');
        }

        const url = typeof this.config.routes.updateNf === 'function'
            ? this.config.routes.updateNf(nfId)
            : `${this.config.routes.updateNf}/${nfId}`;

        const self = this;
        $.ajax({
            url,
            type: 'POST',
            data: fd,
            processData: false,
            contentType: false,
            success: function(response) {
                const nf = response?.data || response?.nf;
                if (response.success && nf) {
                    self.updateDbNfRow(nf);
                    self.closeNfModal(formNf);
                } else {
                    alert('Erro ao atualizar nota fiscal: ' + (response.message || ''));
                }
            },
            error: function() {
                alert('Erro ao atualizar nota fiscal. Tente novamente.');
            }
        });
    }

    /**
     * Insere uma linha de NF vinda do banco na tabela
     */
    appendDbNfRow(nf) {
        const tipoMap = { servico: 'Serviço', produto: 'Produto' };
        const tipoDoc = nf.tipo_arquivo === 'pdf'
            ? '<i class="sg sg-file-pdf text-danger"></i> PDF'
            : '<i class="sg sg-file-code text-primary"></i> XML';

        const dataFormatada = nf.data_emissao
            ? new Date(nf.data_emissao + 'T00:00:00').toLocaleDateString('pt-BR')
            : '-';
        const valorFormatado = nf.valor_total
            ? `R$ ${parseFloat(nf.valor_total).toFixed(2).replace('.', ',')}`
            : 'R$ 0,00';
        const downloadBase = (window.serviceOrderConfig && window.serviceOrderConfig.routes && window.serviceOrderConfig.routes.downloadNfBase)
            ? window.serviceOrderConfig.routes.downloadNfBase
            : '/OS/nf';
        const downloadUrl = nf.id ? `${downloadBase}/${nf.id}/download` : null;
        const arquivoDisplay = nf.nome_arquivo_original
            ? `<span class="badge bg-primary">${nf.nome_arquivo_original}</span>`
            : '-';
        const arquivoHtml = nf.arquivo && downloadUrl
            ? `${arquivoDisplay} <a href="${downloadUrl}" class="btn btn-link" download><i class="sg sg-download"></i></a>`
            : arquivoDisplay;

        const rowHtml = `
            <tr class="nf-js">
                <td>${tipoMap[nf.tipo] || nf.tipo}</td>
                <td>${nf.numero_nota}</td>
                <td>${nf.serie || ''}</td>
                <td>${dataFormatada}</td>
                <td>${valorFormatado}</td>
                <td>${tipoDoc}</td>
                <td>${arquivoHtml}</td>
                <td class="text-end">
                    <div class="dropdown">
                        <a href="#" class="btn btn-link btn-link--hover" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="sg sg-dots-three-vertical-bold"></i>
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item btn-edit-nf" href="#" data-nf-id="${nf.id}"><i class="sg sg-edit me-2"></i>Editar</a></li>
                            <li><a class="dropdown-item btn-delete-nf text-danger" href="#" data-nf-id="${nf.id}"><i class="sg sg-trash me-2"></i>Excluir</a></li>
                        </ul>
                    </div>
                </td>
            </tr>`;

        const tbody = $('.tbodyNf');
        // Remove placeholder quando necessário
        const placeholder = tbody.find('tr td[colspan="8"]');
        if (placeholder.length) placeholder.closest('tr').remove();
        tbody.append(rowHtml);
    }

    /**
     * Atualiza a linha de NF existente (do banco) na tabela
     */
    updateDbNfRow(nf) {
        const row = $(`.tbodyNf .btn-edit-nf[data-nf-id="${nf.id}"]`).closest('tr');
        if (!row.length) return;
        const tipoMap = { servico: 'Serviço', produto: 'Produto' };
        const tipoDoc = nf.tipo_arquivo === 'pdf'
            ? '<i class="sg sg-file-pdf text-danger"></i> PDF'
            : '<i class="sg sg-file-code text-primary"></i> XML';
        const dataFormatada = nf.data_emissao
            ? new Date(nf.data_emissao + 'T00:00:00').toLocaleDateString('pt-BR')
            : '-';
        const valorFormatado = nf.valor_total
            ? `R$ ${parseFloat(nf.valor_total).toFixed(2).replace('.', ',')}`
            : 'R$ 0,00';
        const downloadBase = (window.serviceOrderConfig && window.serviceOrderConfig.routes && window.serviceOrderConfig.routes.downloadNfBase)
            ? window.serviceOrderConfig.routes.downloadNfBase
            : '/OS/nf';
        const downloadUrl = nf.id ? `${downloadBase}/${nf.id}/download` : null;
        const arquivoDisplay = nf.nome_arquivo_original
            ? `<span class="badge bg-primary">${nf.nome_arquivo_original}</span>`
            : '-';
        const arquivoHtml = nf.arquivo && downloadUrl
            ? `${arquivoDisplay} <a href="${downloadUrl}" class="btn btn-link" download><i class="sg sg-download"></i></a>`
            : arquivoDisplay;

        const cells = row.find('td');
        cells.eq(0).text(tipoMap[nf.tipo] || nf.tipo);
        cells.eq(1).text(nf.numero_nota);
        cells.eq(2).text(nf.serie || '');
        cells.eq(3).text(dataFormatada);
        cells.eq(4).text(valorFormatado);
        cells.eq(5).html(tipoDoc);
        cells.eq(6).html(arquivoHtml);
    }

    /**
     * Obter dados das NFs para submissão do formulário
     * @returns {Array} Array com dados das NFs
     */
    getNfsData() {
        return this.nfsData;
    }

    /**
     * Definir dados das NFs (usado para carregar NFs existentes)
     * @param {Array} nfsData - Array com dados das NFs
     */
    setNfsData(nfsData) {
        this.nfsData = nfsData || [];
        this.renderNfTable();
    }

    /**
     * Adicionar dados das NFs ao formulário principal
     * @param {HTMLFormElement} mainForm - Formulário principal
     */
    addNfsToForm(mainForm) {
        this.nfsData.forEach((nf, index) => {
            $(mainForm).append(`<input type="hidden" name="nfs[${index}][tipo]" value="${nf.tipo}">`);
            $(mainForm).append(`<input type="hidden" name="nfs[${index}][numero_nota]" value="${nf.numero_nota}">`);
            $(mainForm).append(`<input type="hidden" name="nfs[${index}][serie]" value="${nf.serie}">`);
            $(mainForm).append(`<input type="hidden" name="nfs[${index}][data_emissao]" value="${nf.data_emissao}">`);
            $(mainForm).append(`<input type="hidden" name="nfs[${index}][valor_total]" value="${nf.valor_total}">`);
            $(mainForm).append(`<input type="hidden" name="nfs[${index}][observacoes]" value="${nf.observacoes || ''}">`);
            
            if (nf.arquivo) {
                $(mainForm).append(`<input type="hidden" name="nfs[${index}][tipo_arquivo]" value="${nf.tipo_arquivo}">`);
                
                const fileInput = document.createElement('input');
                fileInput.type = 'file';
                fileInput.name = `nfs[${index}][arquivo]`;
                fileInput.style.display = 'none';
                
                const dt = new DataTransfer();
                dt.items.add(nf.arquivo);
                fileInput.files = dt.files;
                
                mainForm.appendChild(fileInput);
            }
        });
    }
}

// Exportar para uso global
window.NfManager = NfManager;
